export default {
  getOrder(state) {
    return state.order;
  },
  getOrders(state) {
    return state.orders;
  },
  getOrderPaymentMethods(state) {
    return state.paymentMethods;
  },
  getOrderPaymentUponDeliveryTypes(state) {
    return state.paymentUponDeliveryTypes;
  },
  getOrderPaymentStates(state) {
    return state.paymentStates;
  },
  getOrderPaymentStatesMap(state) {
    return state.paymentStatesMap;
  },
  getOrderDeliveryMethods(state) {
    return state.deliveryMethods;
  },
  getOrderDeliveryStates(state) {
    return state.deliveryStates;
  },
  getOrderDeliveryStatesMap(state) {
    return state.deliveryStatesMap;
  },
  getCart(state) {
    return state.cart;
  },
  getCartIGV(state) {
    return state.cartIGV;
  },
};
